import React from 'react'
import styled from 'styled-components'
import { CardRow } from '../../../../../../generic/ui/CardRow'
import { Mono } from '../../../../../../generic/ui/Mono'
import { Tag } from '../../../../../../generic/ui/Tag'
import CalendarIcon from '../../../../../../generic/icons/IconLib/CalendarIcon'
import ClockIcon from '../../../../../../generic/icons/IconLib/ClockIcon'
import UserIcon from '../../../../../../generic/icons/IconLib/UserIcon'
import { IWorkerHistoryRowView } from '../helpers/workerHistory'

interface WorkerHistoryCardProps {
    view: IWorkerHistoryRowView
    isLast?: boolean
}

const WorkerHistoryCard: React.FC<WorkerHistoryCardProps> = ({ view, isLast = false }) => {
    return (
        <CardRow
            $columns='auto minmax(0, 1fr) auto'
            $mobileColumns='auto minmax(0, 1fr) auto'
            $isLast={isLast}
        >
            <CardRow.Cell>
                <CardRow.Stack $gap='0.25rem'>
                    {view.dateTime && (
                        <>
                            <CardRow.Line $gap='0.375rem'>
                                <MetaIcon>
                                    <CalendarIcon color='currentColor' size={14} />
                                </MetaIcon>
                                <When>{view.dateTime.date}</When>
                            </CardRow.Line>
                            <CardRow.Line $gap='0.375rem'>
                                <MetaIcon>
                                    <ClockIcon color='currentColor' size={14} />
                                </MetaIcon>
                                <When>{view.dateTime.time}</When>
                            </CardRow.Line>
                        </>
                    )}
                    <Tag variant='tinted' color={view.actionColor}>
                        {view.actionLabel}
                    </Tag>
                </CardRow.Stack>
            </CardRow.Cell>

            <CardRow.Cell>
                <CardRow.Stack $gap='0.25rem'>
                    <CardRow.Line $gap='0.5rem' $wrap>
                        <FromWorker>{view.fromWorkerLabel}</FromWorker>
                        <ArrowChar>←</ArrowChar>
                        <ToWorker>{view.toWorkerLabel}</ToWorker>
                    </CardRow.Line>
                    {view.pickupOrderLabel && (
                        <CardRow.Line $gap='0.375rem'>
                            <MetaText>סדר ליקוט</MetaText>
                            <MetaValue>{view.pickupOrderLabel}</MetaValue>
                        </CardRow.Line>
                    )}
                </CardRow.Stack>
            </CardRow.Cell>

            <CardRow.Cell $align='end'>
                <CardRow.Line $gap='0.375rem'>
                    <MetaIcon>
                        <UserIcon color='currentColor' size={14} />
                    </MetaIcon>
                    <MetaText>{view.userLabel}</MetaText>
                </CardRow.Line>
            </CardRow.Cell>
        </CardRow>
    )
}

export default WorkerHistoryCard

const MetaIcon = styled.span`
    display: inline-flex;
    align-items: center;
    color: ${({ theme }) => theme.colors.ink3};
    flex-shrink: 0;
`

const When = styled(Mono)`
    font-size: ${({ theme }) => theme.text.sm};
    color: ${({ theme }) => theme.colors.ink4};
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: ${({ theme }) => theme.textMobile.sm};
    }
`

const FromWorker = styled.span`
    font-size: ${({ theme }) => theme.text.md};
    color: ${({ theme }) => theme.colors.ink3};
    font-family: ${({ theme }) => theme.fonts.sans};
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: ${({ theme }) => theme.textMobile.md};
    }
`

const ToWorker = styled.span`
    font-size: ${({ theme }) => theme.text.md};
    color: ${({ theme }) => theme.colors.ink};
    font-weight: 600;
    font-family: ${({ theme }) => theme.fonts.sans};
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: ${({ theme }) => theme.textMobile.md};
    }
`

const ArrowChar = styled.span`
    color: ${({ theme }) => theme.colors.ink4};
    flex-shrink: 0;
`

const MetaText = styled.span`
    font-size: ${({ theme }) => theme.text.sm};
    color: ${({ theme }) => theme.colors.ink3};
    font-family: ${({ theme }) => theme.fonts.sans};
    white-space: nowrap;
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: ${({ theme }) => theme.textMobile.sm};
    }
`

const MetaValue = styled(Mono)`
    font-size: ${({ theme }) => theme.text.sm};
    color: ${({ theme }) => theme.colors.ink2};
    white-space: nowrap;
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: ${({ theme }) => theme.textMobile.sm};
    }
`
